/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue'

export default {
	getPosts (callback) {
		Vue.http.get('https://blog.pulmoment.com//wp-json/wp/v2/posts')
		.then((response) => {
			callback(null, response.body)
		}, (err) => {
			if (err) {
				console.log(err)
			}
			callback(err.status)
		});
	}
}



// WEBPACK FOOTER //
// ./src/services/BlogService.js